import { useForm } from 'react-hook-form'
import { Form } from 'antd'

import { InvoiceFormValues } from './schema'
import { Invoice } from 'types'
import InvoiceBottomBarAction from './InvoiceBottomBarAction'
import InvoiceMainDataField from './InvoiceMainDataField'
import { useInvoiceFormDefaultValues } from './useInvoiceFormDefaultValues'
import InvoiceLinesFields from './InvoiceLinesFields'
import './InvoiceForm.css'

interface InvoiceFormProps {
  invoice: Invoice | null
  onSave: (data: InvoiceFormValues) => void
}

const InvoiceForm = ({ invoice, onSave }: InvoiceFormProps) => {
  const defaultValues = useInvoiceFormDefaultValues(invoice)

  const { handleSubmit, control, watch } = useForm<InvoiceFormValues>({
    defaultValues,
    mode: 'onChange',
    reValidateMode: 'onChange',
    criteriaMode: 'all',
  })

  const onSubmit = (data: InvoiceFormValues) => {
    onSave(data)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='invoice-form-content'>
        <div>
          <div className={'bg-white shadow-lg rounded-lg p-5'}>
            <Form disabled={invoice?.finalized}>
              <InvoiceMainDataField control={control} invoice={invoice} />

              <div className='mt-4'>
                  <InvoiceLinesFields control={control} watch={watch} />
              </div>
            </Form>
          </div>
        </div>
      </div>

      <InvoiceBottomBarAction isUpdate={!!invoice} />
    </form>
  )
}

export default InvoiceForm
